export interface CalendarEvent {
  id:           number;
  event_date:   string;
  event:        Event;
  event_status: CalendarEventStatus;
  unit:         Event;
  settlement:   Event;
}

export interface Event {
  id:   number;
  name: string;
}

export interface CalendarEventType {
  id: number;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}

export const CALENDAR_EVENT_STATUS_NAMES = [
  'COMPLETED',
  'IN_PROGRESS',
  'CANCELED',
  'PENDING',
  'OVERDUE'
] as const;

export type CalendarEventStatusName = typeof CALENDAR_EVENT_STATUS_NAMES[number];

export interface CalendarEventStatus {
  id: number;
  name: CalendarEventStatusName;
  description?: string;
  created_at?: string;
  updated_at?: string;
}

export interface EventMapItem {
  id:          number;
  settlement:  any;
  unit_id:     number;
  unit_name:   string;
  date:        string;
  eventTypeId: number;
  eventName:   string;
  eventStatus: CalendarEventStatus;
  description: string;
}

export interface CalendarEventStatusUpdateResult {
  eventId: number;
  success: boolean;
  event?: CalendarEvent;
  error?: unknown;
}

export interface Settlement {
  id:           number;
  name:         string;
  cycle_day:    number;
  credit:       number;
  periodicity:  number;
  utility_id:   number;
  utility_name: string;
}

export const EVENTS_NAME_DESCRIPTION: Record<string, string> = {
  SUPPLY_CUT: "Corte de Suministro",
  CLIENT_REACTIVATION: "Reactivación de Cliente",
  RECEIPT_DELIVERY: "Entrega de Recibos",
  PREVENTIVE_MAINTENANCE: "Mantenimiento Preventivo",
  GAS_SUPPLY: "Suministro de Gas",
  RESIDENTIAL_PAYMENT_DEADLINE: "Fecha Límite Pago Habitacional",
  OPERATIONS_START: "Inicio de Operaciones",
  GENERATE_RESIDENTIAL_RECEIPT: "Generar Recibo Habitacional",
  GENERATE_GENERAL_PUBLIC_INVOICE: "Generar Factura Público General",
  RECONNECTION: "Reconexion",
  COMMERCIAL_PAYMENT_DEADLINE: "Fecha Límite Pago Comercial",
  GENERATE_COMMERCIAL_INVOICE: "Generar Factura Comercial",
  GENERATE_RESIDENTIAL_INVOICE: "Generar Factura Habitacional",
  CONSUMPTION_METER_READING: "Lectura Medidor Consumo",
  CLIENT_DEACTIVATION: "Desactivación de Cliente",
  CORRECTIVE_MAINTENANCE: "Mantenimiento Correctivo",
  TANK_LEVEL_READING: "Lectura de Nivel de Tanque",
  GENERATE_COMMERCIAL_RECEIPT: "Generar Recibo Comercial",
  GENERATE_GROUPED_COMMERCIAL_INVOICES: "Generar Facturas Agrupados Comercial"
};
